const DEFAULT_PREVIOUS_PAGE_KEY = 'previousPage';

window.zasIsPage = {
  setPreviousPage: function () {
    const anchor = $('#pageAnchor')

    if (anchor) {
      const name = anchor.data()?.pageName ?? DEFAULT_PREVIOUS_PAGE_KEY;
      localStorage.setItem(name, window.location.href);
    }
  },
  getPreviousPage: function (name) {
    if (!name) {
      name = DEFAULT_PREVIOUS_PAGE_KEY;
    }

    return localStorage.getItem(name);
  },
  navigateToPreviousPage: function (name) {
    window.location.href = this.getPreviousPage(name);
  }
}

window.zasIsPage.setPreviousPage();
